import React, { useState, useEffect } from 'react';
import { Clock, LogOut, RefreshCw, AlertCircle } from 'lucide-react';

const SessionTimeoutModal = ({ isOpen, countdown, onExtend, onLogout }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-300">
            <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-2xl w-full max-w-md overflow-hidden border border-white/20 dark:border-gray-700 animate-in zoom-in-95 duration-300">
                {/* Header Decoration */}
                <div className="h-2 bg-gradient-to-r from-amber-400 via-orange-500 to-red-500" />
                
                <div className="p-8 text-center">
                    <div className="mx-auto w-20 h-20 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mb-6 animate-pulse">
                        <Clock className="w-10 h-10 text-amber-600 dark:text-amber-400" />
                    </div>
                    
                    <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                        Oturum Süresi Doluyor
                    </h3>
                    
                    <p className="text-gray-500 dark:text-gray-400 mb-8 leading-relaxed">
                        Uzun süredir işlem yapmadığınız fark edildi. Güvenliğiniz için oturumunuz otomatik olarak sonlandırılacaktır.
                    </p>

                    <div className="bg-gray-50 dark:bg-gray-700/50 rounded-2xl p-6 mb-8 border border-gray-100 dark:border-gray-600">
                        <div className="text-sm uppercase tracking-wider text-gray-400 dark:text-gray-500 font-semibold mb-1">
                            Kalan Süre
                        </div>
                        <div className="text-4xl font-mono font-bold text-indigo-600 dark:text-indigo-400">
                            {Math.floor(countdown / 60)}:{String(countdown % 60).padStart(2, '0')}
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <button
                            onClick={onLogout}
                            className="flex items-center justify-center px-6 py-3.5 rounded-xl border-2 border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 font-semibold hover:bg-gray-50 dark:hover:bg-gray-700 transition-all active:scale-95"
                        >
                            <LogOut className="w-5 h-5 mr-2" />
                            Çıkış Yap
                        </button>
                        
                        <button
                            onClick={onExtend}
                            className="flex items-center justify-center px-6 py-3.5 rounded-xl bg-indigo-600 text-white font-semibold shadow-lg shadow-indigo-200 dark:shadow-none hover:bg-indigo-700 transition-all active:scale-95"
                        >
                            <RefreshCw className="w-5 h-5 mr-2" />
                            Devam Et
                        </button>
                    </div>
                </div>

                <div className="px-8 py-4 bg-gray-50/50 dark:bg-gray-800/50 border-t border-gray-100 dark:border-gray-700 flex items-center justify-center">
                    <AlertCircle className="w-4 h-4 text-gray-400 mr-2" />
                    <span className="text-xs text-gray-400 dark:text-gray-500 font-medium">
                        Oturumu uzatmak için Devam Et butonuna tıklayın.
                    </span>
                </div>
            </div>
        </div>
    );
};

export default SessionTimeoutModal;
